import { useEffect, useState } from 'react';
import axios from 'axios';
import { getApiUrl } from '../../utils/api';

/* LOT 71 · P10 · un seul appel /missions360 partagé par la barre de gauche, la barre du bas et la fenêtre Modules */
let cache = null; let promesse = null; let t0 = 0;
const charger = (force) => {
  if (!force && (cache || promesse) && Date.now() - t0 < 60000) return promesse || Promise.resolve(cache);
  t0 = Date.now();
  promesse = axios.get(`${getApiUrl()}/missions360`, { withCredentials: true }).then((r) => { cache = r.data; return cache; }).catch(() => cache).finally(() => { promesse = null; });
  return promesse;
};

export const useMissions71 = () => {
  const [d, setD] = useState(cache);
  useEffect(() => {
    let vivant = true;
    const maj = (force) => charger(force).then((x) => vivant && setD(x));
    maj(false);
    const h = () => maj(true);
    window.addEventListener('credits-changed', h); window.addEventListener('missions-changed', h);
    return () => { vivant = false; window.removeEventListener('credits-changed', h); window.removeEventListener('missions-changed', h); };
  }, []);
  return d;
};

// la mission montrée : celle en cours, sinon la conseillée ; ses étapes et l'avancement
export const missionCourante71 = (d) => {
  if (!d) return null;
  const ec = d.en_cours || [];
  const m = ec[0] || (d.en_avant || [])[0] || (d.conseillees || [])[0] || (d.missions || []).find((x) => x.etat === 'disponible');
  if (!m) return null;
  const et = (m.en_cours?.par_semaine || []).flatMap((w) => w.etapes);
  const fait = et.filter((e) => e.fait).length;
  return { m, ec, et, fait, p: et.length ? fait / et.length : 0, n_conseillees: (d.conseillees || []).length };
};
